import { useMemo } from 'react';

import { ContextualCategory } from '@insights_module/types/Traceability';
import { useSelectedEpisodeDetails } from '@insights_module/hooks/useGraphqlAudioDetails';

export const useEpisodeContextual = () => {
  const { data: selectedEpisodeDetails, isLoading } = useSelectedEpisodeDetails();

  const contextualData = useMemo(() => {
    const contextualData = (selectedEpisodeDetails?.contextual || []) as ContextualCategory[];

    return contextualData.sort((a, b) => {
      if (a.score > b.score) {
        return -1;
      }
      if (a.score < b.score) {
        return 1;
      }
      return 0;
    });
  }, [selectedEpisodeDetails]);

  return { contextualData, isLoading };
};
